import { useDocumentsData } from "@/data/use-documents-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";
import { groupKitDocumentControllerCreateResearchProcess } from "@/lib/gen-brain";
import { useState } from "react";

type CreateResearchParams = {
  documentName: string;
  researchContext: string;
  fileUuids: string[];
  documentUuids: string[];
  archetype: "research" | "lavin-speaker";
  expertUuid?: string | null;
};

export function useCreateResearchAction() {
  const [isCreatingResearch, setIsCreatingResearch] = useState(false);
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const { refetchDocuments } = useDocumentsData(groupUuid, kitUuid);

  async function createResearch({
    documentName,
    researchContext,
    archetype,
    documentUuids,
    fileUuids,
  }: CreateResearchParams): Promise<string | undefined> {
    if (!kitUuid || !groupUuid) {
      throw new Error("Kit UUID, group UUID are required");
    }

    setIsCreatingResearch(true);

    const documentUuid = await groupKitDocumentControllerCreateResearchProcess({
      path: {
        kitUuid,
        groupUuid,
      },
      body: {
        name: documentName,
        userContext: researchContext,
        archetype,
        documentUuids,
        fileUuids,
      },
    });

    await refetchDocuments();

    setIsCreatingResearch(false);

    return documentUuid.data;
  }

  return {
    createResearch,
    isCreatingResearch,
  };
}
